/**
 * Product-properties slice (SCRUM-1953, RTK bundle 4) — the former switch
 * reducer ProductPropertiesReducer.js as createSlice. Behaviour-preserving:
 * every case answers the same legacy action type string
 * (ProductPropertiesTypes.js, plus CLEAR_PRODUCTS from productTypes.js) that
 * the actions modules already dispatch, and returns the same state. The actions
 * module is unchanged, so no importer changes. `CLEAR_MESSAGE` is the same
 * string categories answers to; each slice clears its own message.
 * Characterised by tests/integration/reducers/catalogueReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import { legacyCases } from "../legacyCases";
import {
  GET_ALL_PP,
  CLEAR_MESSAGE,
  GET_PP,
  GET_PRODUCTS,
  ADD_PRODUCT_PROPERTIES,
  UPDATE_PRODUCTPROPERTIES,
  CLEAR_PP,
} from "./ProductPropertiesTypes";
import { CLEAR_PRODUCTS } from "../productServices/productTypes";
import type { MessageResponse } from "../../../../shared/apiTypes";

type ProductPropertiesState = {
  productproperties: any[];
  products: any[];
  productpropertiesbyid: any;
  message: string;
};

const initialState: ProductPropertiesState = {
  productproperties: [],
  products: [],
  productpropertiesbyid: {},
  message: "",
};

const productPropertiesCases = {
  [CLEAR_MESSAGE]: (state: ProductPropertiesState) => ({ ...state, message: "" }),
  [GET_ALL_PP]: "productproperties" as const,
  [GET_PP]: "productpropertiesbyid" as const,
  [CLEAR_PP]: (state: ProductPropertiesState) => ({ ...state, productpropertiesbyid: {} }),
  [GET_PRODUCTS]: "products" as const,
  [CLEAR_PRODUCTS]: (state: ProductPropertiesState) => ({ ...state, products: [] }),
  [ADD_PRODUCT_PROPERTIES]: (state: ProductPropertiesState, payload: MessageResponse) => ({
    ...state,
    message: payload.msg,
  }),
  [UPDATE_PRODUCTPROPERTIES]: (state: ProductPropertiesState, payload: MessageResponse) => ({
    ...state,
    message: payload.msg,
  }),
};

const productPropertiesSlice = createSlice({
  name: "productproperties",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    legacyCases(builder, productPropertiesCases);
  },
});

export default productPropertiesSlice.reducer;
